import { DataSourceType } from "@coeff/api";
import { Avatar } from "antd";
import { AvatarSize } from "antd/lib/avatar/SizeContext";
import * as React from "react";
import styled from "styled-components";

import {
  ActiveCampaign,
  Airtable,
  Amplitude,
  Asana,
  AwsBilling,
  Basecamp,
  Bigin,
  BigQuery,
  Calendly,
  Coda,
  Campfire,
  Chargebee,
  Chargify,
  ClickUp,
  CSV,
  CustomAPI,
  Etsy,
  Excel,
  FacebookAds,
  Freshdesk,
  Gong,
  GoogleAds,
  GoogleAnalytics,
  GoogleAnalytics4,
  GoogleCalender,
  AmazonSellerCentral,
  Airwallex,
  Statsig,
  ModernTreasury,
  RudderStack,
  BrightData,
  Vwo,
  Partnerize,
  Rillet,
  Trolley,
  Scalefusion,
  Baremetrics,
  Todoist,
  Workable,
  Plausible,
  Apify,
  DataScope,
  Gorgias,
  Everhour,
  ExchangeRates,
  FastBill,
  GlassFrog,
  Hubplanner,
  Katana,
  MyHours,
  Railz,
  Tellent,
  SimFin,
  Smartwaiver,
  Lokalise,
  MailerLite,
  MailerSend,
  OneSignal,
  Postmark,
  ShortIo,
  Yotpo,
  ChartMogul,
  ConfigCat,
  Pingdom,
  Retently,
  CoinMarketCap,
  Softr,
  EmailOctopus,
  Gridly,
  Mixmax,
  ReplyIo,
  LessAnnoyingCrm,
  SnovIo,
  OnePageCrm,
  Lemlist,
  GoogleDrive,
  GoogleSearchConsole,
  Gmail,
  GoogleSheet,
  Greenhouse,
  Gusto,
  Harvest,
  HubSpot,
  Instagram,
  Intercom,
  Jira,
  Jotform,
  Klaviyo,
  Lever,
  LinkedIn,
  Looker,
  Mailchimp,
  Marketo,
  MongoDB,
  MSSQL,
  MySQL,
  NetflixQuiver,
  Netsuite,
  Motherduck,
  Notion,
  OneDrive,
  Outreach,
  Paymo,
  Pinterest,
  Pipedrive,
  Podio,
  Aurora,
  CloudSql,
  Neon,
  Supabase,
  Clickhouse,
  Azure,
  Timescaledb,
  Postgres,
  Quickbooks,
  QUORA_ADS,
  Razorpay,
  RedditAds,
  Redshift,
  Salesforce,
  Sendgrid,
  Shopify,
  Smartsheet,
  Snowflake,
  Square,
  Stripe,
  SurveyMonkey,
  Tableau,
  TableIcon,
  Trello,
  Typeform,
  Webflow,
  Xero,
  YouTube,
  Zendesk,
  Zohobooks,
  ZohoCrm,
  Zoom,
  Salesloft,
  WordPress,
  WooCommerce,
  BigCommerce,
  Smartlead,
  Affinity,
  Shiprocket,
  ArrowFlightSQL,
  Databricks,
  Rippling,
  Apollo,
  Sage,
  GoogleClassroom,
  SharePoint,
  Metabase,
  Teamwork,
  CatsAts,
  Freshservice,
  Hive,
  Aircall,
  NimbleCrm,
  Drip,
  Paddle,
  AgileCrm,
  Checkout,
  CapsuleCrm,
  Nutshell,
  Pipeliner,
  Salesflare,
  VtigerCrm,
  Bitbucket,
  GitLabAi,
  HelpScoutAi,
  FrontAi,
  WrikeAi,
  BambooHr,
  DeelAi,
  ConfluenceAi,
  Teamleader,
  MiroAi,
  OmnisendAi,
  AttioAi,
  CreatioAi,
  FreeAgentAi,
  MoneybirdAi,
  AcceloAi,
  ApplicantstackAi,
  AlowareAi,
  StackbyAi,
  FloatAi,
  ClickhouseAi,
  AppsflyerAi,
  MariaDB,
  LaunchDarkly,
  PostHog,
  Dovetail,
  Shipstation,
  Mindbody,
  Groww,
} from "./";

interface ImportTypeIconProps {
  type?: DataSourceType;
  size?: AvatarSize;
}

const StyledAvatar = styled(Avatar)`
  background: none;

  svg {
    ${({ size }) => {
      switch (size) {
        case "large": {
          return `
            height: 40px;
            width: 40px;
        `;
        }
        case "default": {
          return `
            height: 32px !important;
            width: 32px !important;
        `;
        }
        case "small": {
          return `
            height: 24px !important;
            width: 24px !important;
        `;
        }
        default: {
          return `
          height: 40px;
          width: 40px;`;
        }
      }
    }}
  }
`;

export const ImportTypeIcon = ({ type, size = "large" }: ImportTypeIconProps) => {
  switch (type) {
    case "airtable":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Airtable />} />;
    case "amplitude":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Amplitude />} />;
    case "bigquery":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<BigQuery />} />;
    case "cloud_table":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<TableIcon />} />;
    case "campfire":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Campfire />} />;
    case "rillet":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Rillet />} />;
    case "chargebee":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Chargebee />} />;
    case "chargify":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Chargify />} />;
    case "csv":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<CSV />} />;
    case "gong":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Gong />} />;
    case "google_analytics":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<GoogleAnalytics />} />;
    case "google_drive":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<GoogleDrive />} />;
    case "google_sheets":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<GoogleSheet />} />;
    case "excel":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Excel />} />;
    case "hubspot":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<HubSpot />} />;
    case "instagram_insights":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Instagram />} />;
    case "jira":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Jira />} />;
    case "klaviyo":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Klaviyo />} />;
    case "linkedin":
    case "linkedin_ads":
    case "linkedin_pages":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<LinkedIn />} />;
    case "looker":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Looker />} />;
    case "mailchimp":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Mailchimp />} />;
    case "marketo":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Marketo />} />;
    case "mongodb":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<MongoDB />} />;
    case "mysql":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<MySQL />} />;
    case "mssql":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<MSSQL />} />;
    case "netflix_quiver":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<NetflixQuiver />} />;
    case "netsuite":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Netsuite />} />;
    case "one_drive":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<OneDrive />} />;
    case "motherduck":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Motherduck />} />;
    case "outreach":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Outreach />} />;
    case "pipedrive":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Pipedrive />} />;
    case "postgres":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Postgres />} />;
    case "aurora_postgres":
    case "aurora_mysql":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Aurora />} />;
    case "cloud_sql_postgres":
    case "cloud_sql_mysql":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<CloudSql />} />;
    case "supabase":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Supabase />} />;
    case "neon":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Neon />} />;
    case "timescaledb":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Timescaledb />} />;
    case "azure_postgres":
    case "azure_mysql":
    case "azure_sql":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Azure />} />;
    case "clickhouse":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Clickhouse />} />;
    case "quickbooks":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Quickbooks />} />;
    case "redshift":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Redshift />} />;
    case "salesforce":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Salesforce />} />;
    case "sendgrid":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Sendgrid />} />;
    case "shopify":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Shopify />} />;
    case "snowflake":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Snowflake />} />;
    case "stripe":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Stripe />} />;
    case "tableau":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Tableau />} />;
    case "zendesk":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Zendesk />} />;
    case "google_analytics_4":
      return (
        <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<GoogleAnalytics4 />} />
      );
    case "facebook_ads":
    case "facebook_insights":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<FacebookAds />} />;
    case "google_search_console":
      return (
        <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<GoogleSearchConsole />} />
      );
    case "gmail":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Gmail />} />;
    case "google_ads":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<GoogleAds />} />;
    case "notion":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Notion />} />;
    case "greenhouse":
    case "greenhouse_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Greenhouse />} />;
    case "xero":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Xero />} />;
    case "custom_api":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<CustomAPI />} />;
    case "youtube_analytics":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<YouTube />} />;
    case "asana":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Asana />} />;
    case "razorpay":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Razorpay />} />;
    case "clickup":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<ClickUp />} />;
    case "typeform":
    case "typeform_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Typeform />} />;
    case "harvest":
    case "harvest_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Harvest />} />;
    case "freshdesk":
    case "freshdesk_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Freshdesk />} />;
    case "paymo":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Paymo />} />;
    case "google_calendar":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<GoogleCalender />} />;
    case "amazon_seller_central":
      return (
        <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<AmazonSellerCentral />} />
      );
    case "trello":
    case "trello_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Trello />} />;
    case "calendly":
    case "calendly_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Calendly />} />;
    case "smartsheet":
    case "smartsheet_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Smartsheet />} />;
    case "reddit_ads":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<RedditAds />} />;
    case "surveymonkey":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<SurveyMonkey />} />;
    case "quora_ads":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<QUORA_ADS />} />;
    case "podio":
    case "podio_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Podio />} />;
    case "gusto":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Gusto />} />;
    case "intercom":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Intercom />} />;
    case "etsy":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Etsy />} />;
    case "pinterest_ads":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Pinterest />} />;
    case "active_campaign":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<ActiveCampaign />} />;
    case "basecamp":
    case "basecamp_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Basecamp />} />;
    case "jotform":
    case "jotform_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Jotform />} />;
    case "zohobooks":
    case "zohobooks_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Zohobooks />} />;
    case "coda":
    case "coda_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Coda />} />;
    case "square":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Square />} />;
    case "zoom":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Zoom />} />;
    case "webflow":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Webflow />} />;
    case "zoho_crm":
    case "zoho_crm_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<ZohoCrm />} />;
    case "bigin":
    case "bigin_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Bigin />} />;
    case "lever":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Lever />} />;
    case "salesloft":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Salesloft />} />;
    case "wordpress":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<WordPress />} />;
    case "woo_commerce":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<WooCommerce />} />;
    case "bigcommerce":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<BigCommerce />} />;
    case "smartlead":
    case "smartlead_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Smartlead />} />;
    case "affinity":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Affinity />} />;
    case "shiprocket":
    case "shiprocket_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Shiprocket />} />;
    case "databricks":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Databricks />} />;
    case "arrow_flight_sql":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<ArrowFlightSQL />} />;
    case "rippling":
    case "rippling_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Rippling />} />;
    case "apollo":
    case "apollo_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Apollo />} />;
    case "sage":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Sage />} />;
    case "aws_billing":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<AwsBilling />} />;
    case "google_classroom":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<GoogleClassroom />} />;
    case "sharepoint_lists":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<SharePoint />} />;
    case "metabase_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Metabase />} />;
    case "teamwork_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Teamwork />} />;
    case "cats_ats_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<CatsAts />} />;
    case "nutshell_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Nutshell />} />;
    case "pipeliner_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Pipeliner />} />;
    case "salesflare_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Salesflare />} />;
    case "vtiger_crm_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<VtigerCrm />} />;
    case "freshservice_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Freshservice />} />;
    case "hive_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Hive />} />;
    case "aircall_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Aircall />} />;
    case "nimble_crm_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<NimbleCrm />} />;
    case "drip_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Drip />} />;
    case "paddle_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Paddle />} />;
    case "agile_crm_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<AgileCrm />} />;
    case "checkout_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Checkout />} />;
    case "capsule_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<CapsuleCrm />} />;
    case "bitbucket_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Bitbucket />} />;
    case "gitlab_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<GitLabAi />} />;
    case "helpscout_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<HelpScoutAi />} />;
    case "front_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<FrontAi />} />;
    case "wrike_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<WrikeAi />} />;
    case "bamboohr_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<BambooHr />} />;
    case "deel_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<DeelAi />} />;
    case "confluence_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<ConfluenceAi />} />;
    case "teamleader_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Teamleader />} />;
    case "miro_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<MiroAi />} />;
    case "omnisend_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<OmnisendAi />} />;
    case "attio_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<AttioAi />} />;
    case "creatio_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<CreatioAi />} />;
    case "freeagent_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<FreeAgentAi />} />;
    case "moneybird_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<MoneybirdAi />} />;
    case "accelo_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<AcceloAi />} />;
    case "applicantstack_ai":
      return (
        <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<ApplicantstackAi />} />
      );
    case "aloware_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<AlowareAi />} />;
    case "stackby_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<StackbyAi />} />;
    case "float_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<FloatAi />} />;
    case "clickhouse_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<ClickhouseAi />} />;
    case "appsflyer_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<AppsflyerAi />} />;
    case "mariadb_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<MariaDB />} />;
    case "launchdarkly_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<LaunchDarkly />} />;
    case "posthog_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<PostHog />} />;
    case "dovetail_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Dovetail />} />;
    case "shipstation_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Shipstation />} />;
    case "mindbody_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Mindbody />} />;
    case "groww_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Groww />} />;
    case "amazon_seller_central_ai":
      return (
        <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<AmazonSellerCentral />} />
      );
    case "airwallex_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Airwallex />} />;
    case "statsig_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Statsig />} />;
    case "modern_treasury_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<ModernTreasury />} />;
    case "rudderstack_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<RudderStack />} />;
    case "bright_data_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<BrightData />} />;
    case "vwo_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Vwo />} />;
    case "partnerize_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Partnerize />} />;
    case "rillet_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Rillet />} />;
    case "trolley_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Trolley />} />;
    case "scalefusion_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Scalefusion />} />;
    case "baremetrics_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Baremetrics />} />;
    case "todoist_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Todoist />} />;
    case "workable_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Workable />} />;
    case "plausible_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Plausible />} />;
    case "apify_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Apify />} />;
    case "datascope_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<DataScope />} />;
    case "gorgias_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Gorgias />} />;
    case "everhour_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Everhour />} />;
    case "exchangerates_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<ExchangeRates />} />;
    case "fastbill_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<FastBill />} />;
    case "glassfrog_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<GlassFrog />} />;
    case "resource_flow_hubplanner_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Hubplanner />} />;
    case "katana_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Katana />} />;
    case "myhours_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<MyHours />} />;
    case "fis_railz_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Railz />} />;
    case "tellent_hris_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Tellent />} />;
    case "simfin_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<SimFin />} />;
    case "smartwaiver_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Smartwaiver />} />;
    case "lokalise_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Lokalise />} />;
    case "mailerlite_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<MailerLite />} />;
    case "mailersend_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<MailerSend />} />;
    case "onesignal_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<OneSignal />} />;
    case "postmark_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Postmark />} />;
    case "short_io_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<ShortIo />} />;
    case "yotpo_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Yotpo />} />;
    case "chartmogul_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<ChartMogul />} />;
    case "configcat_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<ConfigCat />} />;
    case "pingdom_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Pingdom />} />;
    case "retently_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Retently />} />;
    case "coinmarketcap_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<CoinMarketCap />} />;
    case "softr_io_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Softr />} />;
    case "emailoctopus_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<EmailOctopus />} />;
    case "gridly_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Gridly />} />;
    case "mixmax_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Mixmax />} />;
    case "reply_io_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<ReplyIo />} />;
    case "less_annoying_crm_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<LessAnnoyingCrm />} />;
    case "snov_io_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<SnovIo />} />;
    case "onepagecrm_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<OnePageCrm />} />;
    case "lemlist_ai":
      return <StyledAvatar className="dataSourceTypeIcon" size={size} icon={<Lemlist />} />;
    default:
      return <StyledAvatar className="dataSourceTypeIcon" size={size} />;
  }
};
